import { ChevronRight, CalendarDays, FileText } from "lucide-react";
import { cedi2 as cedi } from "@/lib/api";

export const NONE = "__none";

export const specialEvents = (events, items) => {
  const map = new Map(events.map((e) => [e.id, { id: e.id, title: e.title, date: e.date || "", rows: [] }]));
  items.forEach((r) => {
    const k = r.event_id || NONE;
    if (!map.has(k)) map.set(k, { id: k, title: k === NONE ? "Not linked to an event" : r.event_title || "Event", date: "", rows: [] });
    map.get(k).rows.push(r);
  });
  return [...map.values()].sort((a, b) => (a.id === NONE) - (b.id === NONE));
};

const EventCard = ({ ev, onOpen }) => {
  const live = ev.rows.filter((r) => !r.voided);
  const paid = live.filter((r) => r.status === "Paid").reduce((s, r) => s + r.amount, 0);
  const pending = live.filter((r) => r.status === "Pending").reduce((s, r) => s + r.amount, 0);
  const Icon = ev.id === NONE ? FileText : CalendarDays;
  return (
    <button onClick={() => onOpen(ev)} className="w-full text-left bg-white border border-[#E5E7EB] rounded-lg p-4 flex items-center gap-4 hover:border-[#E60000] hover:shadow-sm transition-[border-color,box-shadow]" data-testid={`special-event-${ev.id}`}>
      <div className="w-10 h-10 rounded-md bg-[#FFF0F0] text-[#E60000] grid place-items-center shrink-0"><Icon className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0">
        <div className="font-heading font-bold truncate">{ev.title}</div>
        <div className="text-xs text-gray-500">{ev.date && `${ev.date} · `}{ev.rows.length} receipt(s)</div>
      </div>
      <div className="text-right text-xs">
        <div className="font-mono font-semibold" data-testid={`special-event-received-${ev.id}`}>{cedi(paid)} received</div>
        <div className="text-gray-500">{cedi(pending)} pending</div>
      </div>
      <ChevronRight className="w-4 h-4 text-gray-400" />
    </button>
  );
};

export const SpecialEventList = ({ list, onOpen }) => (
  <div className="space-y-3" data-testid="special-event-list">
    {list.map((ev) => <EventCard key={ev.id} ev={ev} onOpen={onOpen} />)}
    {!list.length && <div className="p-10 text-center text-sm text-gray-500 bg-white border rounded-lg" data-testid="special-no-events">No events found.</div>}
  </div>
);
